import { useLang } from '../context/LanguageContext';
import './AboutPage.css';
import './FaqPage.css';

const FAQ_KEYS = [
  ['faq6q', 'faq6a'],
  ['faq7q', 'faq7a'],
  ['faq8q', 'faq8a'],
  ['faq9q', 'faq9a'],
  ['faq1q', 'faq1a'],
  ['faq2q', 'faq2a'],
  ['faq3q', 'faq3a'],
  ['faq4q', 'faq4a'],
  ['faq5q', 'faq5a'],
];

export default function FaqPage({ onClose }) {
  const { t } = useLang();

  return (
    <div className="page-modal-backdrop" onClick={onClose}>
      <div className="page-modal page-modal--wide" onClick={(e) => e.stopPropagation()}>
        <div className="page-modal-header">
          <h2>{t.faqTitle}</h2>
          <button type="button" className="page-modal-close" onClick={onClose} aria-label={t.closeBtn}>
            ✕
          </button>
        </div>
        <div className="page-modal-body">
          <div className="about-hero faq-hero">
            <div className="faq-hero__icon" aria-hidden>
              ?
            </div>
            <h1>{t.faqTitle}</h1>
            <p className="about-tagline">{t.faqSubtitle}</p>
          </div>

          <div className="faq-list">
            {FAQ_KEYS.map(([qKey, aKey], i) => (
              <details key={qKey} className="faq-item" open={i === 0}>
                <summary className="faq-item__q">
                  <span className="faq-item__num">{String(i + 1).padStart(2, '0')}</span>
                  <span className="faq-item__text">{t[qKey]}</span>
                  <span className="faq-item__chev" aria-hidden />
                </summary>
                <div className="faq-item__a">
                  <p>{t[aKey]}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
